import api from "./api";

const agentsService = {
  // Get all agents
  getAgents: async () => {
    try {
      const response = await api.get("/agents");
      return response.data;
    } catch (error) {
      console.error("Error fetching agents:", error);
      // Return mock data as fallback
      return getMockAgentsData();
    }
  },

  // Get agent details
  getAgent: async (id) => {
    try {
      const response = await api.get(`/agents/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching agent:", error);
      throw error;
    }
  },

  // Create new agent
  createAgent: async (data) => {
    try {
      const response = await api.post("/agents", data);
      return response.data;
    } catch (error) {
      console.error("Error creating agent:", error);
      throw error;
    }
  },

  // Update agent
  updateAgent: async (id, data) => {
    try {
      const response = await api.put(`/agents/${id}`, data);
      return response.data;
    } catch (error) {
      console.error("Error updating agent:", error);
      throw error;
    }
  },

  // Delete agent
  deleteAgent: async (id) => {
    try {
      const response = await api.delete(`/agents/${id}`);
      console.log("✅ Delete Agent Success:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error deleting agent:", error);
      throw error;
    }
  },

  // Test agent chat
  testAgent: async (id, message) => {
    try {
      const response = await api.post(`/agents/${id}/test-chat`, { message });
      return response.data;
    } catch (error) {
      console.error("Error testing agent:", error);
      throw error;
    }
  },
};

// Mock data fallback
const getMockAgentsData = () => ({
  agents: [
    {
      id: 1,
      name: "Customer Support Bot",
      description:
        "Handles general customer inquiries and support requests with intelligent responses",
      model_provider: "groq",
      model_name: "llama-3.3-70b-versatile",
      status: "active",
      hands_off_type: false,
      connected_channels: 3,
      today_cost: 2.45,
      created_at: "2024-01-15T10:30:00Z",
    },
    {
      id: 2,
      name: "Sales Assistant",
      description:
        "Helps potential customers with product information and sales inquiries",
      model_provider: "openai",
      model_name: "gpt-4o",
      status: "active",
      hands_off_type: false,
      connected_channels: 2,
      today_cost: 5.67,
      created_at: "2024-01-18T14:20:00Z",
    },
    {
      id: 3,
      name: "Technical Support",
      description: "Provides technical assistance and troubleshooting guidance",
      model_provider: "anthropic",
      model_name: "claude-3-sonnet",
      status: "inactive",
      hands_off_type: true,
      connected_channels: 1,
      today_cost: 0.89,
      created_at: "2024-01-20T09:15:00Z",
    },
    {
      id: 4,
      name: "Billing Assistant",
      description: "Handles billing questions and payment-related inquiries",
      model_provider: "google",
      model_name: "gemini-pro",
      status: "active",
      hands_off_type: false,
      connected_channels: 1,
      today_cost: 1.23,
      created_at: "2024-01-22T16:45:00Z",
    },
    {
      id: 5,
      name: "Onboarding Guide",
      description:
        "Assists new users with platform onboarding and initial setup",
      model_provider: "groq",
      model_name: "llama-3.1-8b-instant",
      status: "active",
      hands_off_type: false,
      connected_channels: 2,
      today_cost: 0.78,
      created_at: "2024-01-25T11:30:00Z",
    },
  ],
  total: 5,
});

export default agentsService;
